<app-dialog [blur]="true" [minWidthDefault]="false" [showHeader]="false" [show]="show">
  <div *ngIf="show" @fadeInOut class="unlock-pin-dialog-container">
    <div class="header">
      <img class="lock-icon" src="assets/icons/icon-locker.svg" alt="locker">
      Enter PIN to Unlock
    </div>

    <div class="subheader">
      Please enter your 4-digit PIN to continue.
    </div>

    <app-pin-input [(ngModel)]="pinValue"
                   (pinValueComplete)="codeComplete($event)"
                   [isLarge]="true"
                   [disabled]="isDisabled"
                   [invalid]="isInvalid"
                   [focused]="focusPin"
                   #lockScreenPin
    ></app-pin-input>

    <div class="controls">
      <button (click)="forgotPin.emit()" class="animation-focus-default forgot-pin-btn">
        I forgot my PIN
      </button>
    </div>
  </div>
</app-dialog>
